import { Carousel } from "@mantine/carousel";
import { Image } from "@mantine/core";

const IMAGES = [
  {
    src: "/master_wong/master_wong_promotion.jpeg",
  },
  {
    src: "/master_wong/master_wong_1.jpeg",
  },
  {
    src: "/master_wong/master_wong_2.jpeg",
  },
  {
    src: "/master_wong/master_wong_3.jpeg",
  },
  {
    src: "/master_wong/master_wong_4.jpeg",
  },
];

export default function ShowCase() {
  return (
    <Carousel maw={500} mx="auto" withIndicators height={400}>
      {IMAGES.map(({ src }) => (
        <Carousel.Slide>
          <Image src={src} />
        </Carousel.Slide>
      ))}
    </Carousel>
  );
}
